"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";

export default function VerifiedSpondClubBanner() {
  const t = useTranslations();
  const label = t("club.verified");
  const [firstWord, ...restWords] = label.split(" ");
  const restText = restWords.join(" ");
  return (
    <section
      aria-label={label}
      className="border border-gray-200 rounded-sm my-6"
    >
      <div className="container mx-auto py-2 px-4">
        <div className="flex items-center justify-center gap-2">
          <Image
            src="/verified-club.png"
            alt={label}
            width={43}
            height={61}
            sizes="(max-width: 640px) 43px, (max-width: 1024px) 43px, 43px"
            className="transform scale-x-[-1]"
          />

          <span className="text-md text-center font-semibold leading-6">
            {firstWord}
            <br />
            {restText}
          </span>
          <Image
            src="/verified-club.png"
            alt={label}
            width={43}
            height={61}
            sizes="(max-width: 640px) 43px, (max-width: 1024px) 43px, 43px"
          />
        </div>
      </div>
    </section>
  );
}
